export default "__VITE_ASSET__9A2BQk2z__"